import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _templateObject;
import { gql, useMutation } from '@apollo/client';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import _ from 'lodash';
import React from 'react';
import { useStyles } from "./_.style";
export var ProFormDirectUpload = function ProFormDirectUpload(properties) {
  var _properties$entitySto;
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var entityStore = (_properties$entitySto = properties.entityStore) !== null && _properties$entitySto !== void 0 ? _properties$entitySto : 'palmier';
  var entityTransformer = _objectSpread({
    _: 'id'
  }, properties.entityTransformer);
  var _useMutation = useMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation CreateResource($entities: [PartialResource!]!) {\n      ", " {\n        resource {\n          create(entities: $entities) {\n            id\n            url\n            uploadUrl\n          }\n        }\n      }\n    }\n  "])), entityStore)),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    createResources = _useMutation2[0];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(properties.children, _objectSpread(_objectSpread({}, _.omit(properties, ['children', 'entityTransformer'])), {}, {
    transform: function transform(value) {
      if (value) {
        var _properties$max;
        if (((_properties$max = properties.max) !== null && _properties$max !== void 0 ? _properties$max : 1024) > 1) {
          // 多选
          return value.map(function (file) {
            var _file$response;
            return _defineProperty({}, entityTransformer._, (_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.id);
          });
        } else {
          var _value$;
          // 单选
          return (_value$ = value[0]) === null || _value$ === void 0 || (_value$ = _value$.response) === null || _value$ === void 0 ? void 0 : _value$.id;
        }
      } else {
        return {};
      }
    },
    fieldProps: _objectSpread({
      method: 'PUT',
      customRequest: function customRequest(options) {
        _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var externalId, resource, _options$onSuccess, _typedError$response, _typedError$response2, _options$onError, _typedError$response3, typedError, transformedError;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new Promise(function (resolve, reject) {
                  // -
                  var getter = new FileReader();
                  // -
                  // > -
                  getter.addEventListener('loadend', function () {
                    resolve(CryptoJS.SHA1(CryptoJS.lib.WordArray.create(getter.result)).toString(CryptoJS.enc.Hex));
                  });
                  // > -
                  getter.addEventListener('error', reject);
                  // -
                  getter.readAsArrayBuffer(options.file);
                });
              case 2:
                externalId = _context.sent;
                _context.next = 5;
                return createResources({
                  variables: {
                    entities: [_objectSpread({
                      externalId: externalId
                    }, _.pick(options.file, ['name', 'size', 'type']))]
                  }
                }).then(function (response) {
                  return response.data[entityStore].resource.create[0];
                });
              case 5:
                resource = _context.sent;
                _context.prev = 6;
                _context.next = 9;
                return axios.put(resource.uploadUrl, options.file, {
                  headers: {
                    'Content-Type': 'application/octet-stream'
                  },
                  method: options.method,
                  onUploadProgress: function onUploadProgress(event) {
                    var _options$onProgress;
                    // -
                    _.set(event, 'percent', (event.progress || 0) * 100);
                    // -
                    (_options$onProgress = options.onProgress) === null || _options$onProgress === void 0 || _options$onProgress.call(options, event);
                  }
                });
              case 9:
                // 返回结果
                (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 || _options$onSuccess.call(options, resource);
                _context.next = 17;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                // -
                // > -
                typedError = _context.t0; // > -
                transformedError = Object.assign(new Error("Cannot ".concat(options.method, " ").concat(typedError.request.responseURL, " ").concat((_typedError$response = typedError.response) === null || _typedError$response === void 0 ? void 0 : _typedError$response.status, "'")), {
                  method: options.method,
                  url: typedError.request.responseURL,
                  status: (_typedError$response2 = typedError.response) === null || _typedError$response2 === void 0 ? void 0 : _typedError$response2.status
                }); // -
                (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, transformedError, (_typedError$response3 = typedError.response) === null || _typedError$response3 === void 0 ? void 0 : _typedError$response3.data);
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[6, 12]]);
        }))();
      }
    }, properties.fieldProps),
    formItemProps: _objectSpread({
      getValueProps: function getValueProps(value) {
        if (value) {
          // 存储数据
          var formattedValue = value;
          // 预处理数据
          // > 如果入参直接就是一个链接
          if (_.isString(formattedValue)) {
            formattedValue = [{
              url: properties.value
            }];
          }
          // > 如果入参是一个单独的对象
          if (_.isPlainObject(formattedValue)) {
            formattedValue = [formattedValue];
          }
          // 返回数据
          if (_.isArray(formattedValue)) {
            return {
              value: formattedValue.map(function (file) {
                return _objectSpread({
                  // 用于处理空值
                  name: '-',
                  status: 'done',
                  uid: String(Math.random())
                }, file);
              })
            };
          } else {
            return {
              value: value
            };
          }
        } else {
          return {
            value: value
          };
        }
      }
    }, properties.formItemProps)
  })));
};